export default "__VITE_ASSET__efe8415e__"